module.exports = __webpack_public_path__ + "static/media/infectare-fructe-legume.24fc304b.jpeg";